module.exports = __webpack_public_path__ + "static/img/logo.9779c4e5.png";